import { cilCheckCircle } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useLocationStore, usePatientCallSystemStore } from '@/zustandStore.js';

const PrinterDropdown = ({ children }) => {
    const sidebarShow = useSelector((state) => state.sidebarShow);
    const selectedLocation = useLocationStore((state) => state.selectedLocation);
    const selectedPrinter = usePatientCallSystemStore((state) => state.selectedPrinter);

    const printers = useMemo(() => {
        return selectedLocation.configs.flatMap((config) => config.pcs_printers);
    }, [selectedLocation]);

    return (
        <CDropdown size={!sidebarShow ? 'md' : 'sm'} variant="btn-group">
            {children}
            <CDropdownToggle color="secondary" split />
            <CDropdownMenu>
                {printers.map((printer, index) => (
                    <CDropdownItem
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: 'pointer' }}
                        key={printer.name[0].text}
                        onClick={() =>
                            usePatientCallSystemStore.setState({
                                selectedPrinter: {
                                    ...selectedPrinter,
                                    [selectedLocation.key]: printer,
                                },
                            })
                        }
                    >
                        {printer.name[0].text}
                        {(selectedPrinter[selectedLocation.key]?.address?.[0]?.text === printer.address[0].text ||
                            (!selectedPrinter[selectedLocation.key] && index === 0)) && (
                            <CIcon className="text-primary" icon={cilCheckCircle} />
                        )}
                    </CDropdownItem>
                ))}
            </CDropdownMenu>
        </CDropdown>
    );
};

export default PrinterDropdown;
